import { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import { Form } from 'forms/rrf';
import ArrowButton from '../../../components/common/button-arrow';
import SearchableSelect from '../../../components/common/form/elements/searchable-select';
import { getPostcodeplanObjectives } from '../../../actions/pip-epos-data-missing-weeks';
import NumberOfPacksSold from './number-of-packs-sold';
import { weekOfSaleDate } from '../../../utils/commonFunctions';

class AutoEposPriceItPlusForm extends Component {
  handleOutletChange = (outletId) => {
    const { dispatch } = this.props;

    dispatch(getPostcodeplanObjectives(outletId));
  };

  findPostcodeplanObjective = () => {
    const { postcodePlanObjectiveId, postcodeplanObjectives } = this.props;
    const postcodeplanObjective = postcodeplanObjectives.find(objective => objective.id === postcodePlanObjectiveId);

    return postcodeplanObjective;
  };

  weekOfSales = () => {
    const postcodeplanObjective = this.findPostcodeplanObjective();

    if (postcodeplanObjective) {
      return postcodeplanObjective.week_of_sales.map((weekOfSale) => {
        const label = weekOfSaleDate(weekOfSale.date);

        return { value: weekOfSale.date, label };
      });
    }

    return [];
  };

  products = () => {
    const postcodeplanObjective = this.findPostcodeplanObjective();

    if (postcodeplanObjective) {
      const { weekOfSale } = this.props;
      const selectedWeekOfSale = postcodeplanObjective.week_of_sales.find(week => week.date === weekOfSale);

      if (selectedWeekOfSale) {
        return selectedWeekOfSale.products.map(product => ({
          value: product.pip_epos_data_missing_week_id,
          label: product.name
        }));
      }
    }

    return [];
  };

  render() {
    const {
      formValid,
      outletId,
      postcodePlanObjectiveId,
      weekOfSale,
      isLoading,
      model,
      onSubmit,
      outlets,
      postcodeplanObjectives
    } = this.props;
    const objectives = (postcodeplanObjectives || []).map(objective => ({
      value: objective.id,
      label: objective.name
    }));
    const isOutletSelected = outletId !== '';
    const isObjectiveSelected = postcodePlanObjectiveId !== '';
    const isWeekOfSaleSelected = weekOfSale !== '';
    const weekOfSales = this.weekOfSales();

    return (
      <div className="mg-bottom-60 mg-top-10">
        <div className="container-fluid padding-flush">
          <Form
            model={model}
            onSubmit={onSubmit}
            className="sell-it-submissions-tabs-epos-form"
          >
            {isLoading && !isOutletSelected ? 'Loading...' : (
              <Row>
                <Col md={12}>
                  <SearchableSelect
                    label='Outlet Name'
                    model={`${model}.outlet_id`}
                    options={outlets}
                    value={outletId}
                    onChange={this.handleOutletChange}
                    required
                  />
                </Col>
              </Row>
            )}
            {isLoading && isOutletSelected && !isObjectiveSelected && 'Loading...' }
            {!isLoading && isOutletSelected && (
              <Row>
                <Col md={12}>
                  <SearchableSelect
                    label='Postcode Plan Objective'
                    model={`${model}.postcodeplan_objective_id`}
                    options={objectives}
                    value={postcodePlanObjectiveId}
                    required
                  />
                </Col>
              </Row>
            )}
            {isObjectiveSelected && (
              <Row>
                <Col md={12}>
                  <SearchableSelect
                    label='Week of Sale'
                    model={`${model}.week_of_sale`}
                    options={weekOfSales}
                    value={weekOfSale}
                    required
                  />
                </Col>
              </Row>
            )}
            {isWeekOfSaleSelected && (
              <div>
                <NumberOfPacksSold model={model} products={this.products()} />
                <Row>
                  <Col md={12} className="sell-it-submissions-tabs-epos-form-buttons">
                    <ArrowButton className="float-end" arrow={false} disabled={!formValid} submit>
                      Submit
                    </ArrowButton>
                  </Col>
                </Row>
              </div>
            )}
          </Form>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  formValid: state.deep.forms.autoEposPriceItPlus.$form.valid,
  outletId: state.deep.autoEposPriceItPlus.outlet_id,
  postcodePlanObjectiveId: state.deep.autoEposPriceItPlus.postcodeplan_objective_id,
  weekOfSale: state.deep.autoEposPriceItPlus.week_of_sale,
  outlets: state.pipEposDataMissingWeeks.outlets,
  postcodeplanObjectives: state.pipEposDataMissingWeeks.postcodeplanObjectives,
  isLoading: state.pipEposDataMissingWeeks.fetching && !state.pipEposDataMissingWeeks.fetched,
});

export default connect(mapStateToProps)(AutoEposPriceItPlusForm);
